export const contentTableConfig = {
  title: '统计列表',
  propList: [
    {prop: 'thirdParty', label: '所属第三方', minWidth: '50', align: 'left'},
    {prop: 'channel', label: '来源渠道', minWidth: '80', align: 'left'},
    {prop: 'userId', label: '工作微信号', minWidth: '80', align: 'left'},
    {prop: 'userName', label: '使用人', minWidth: '80', align: 'left'},
    {prop: 'corpName', label: '所属主体', minWidth: '80', align: 'left'},
    {prop: 'totalCount', label: '添加人数', minWidth: '60', sortable: true,},
    {prop: 'deletedCount', label: '删微人数', minWidth: '60', sortable: true,},
    {
      prop: 'repeatCount',
      label: '添加人数中的重复数',
      minWidth: '170',
      sortable: true,
      slotName: 'repeatCount',
      headerTip: '添加人数中的重复客户数据'
    },
    {
      prop: 'overlapCount',
      label: '删微重复数',
      minWidth: '90',
      sortable: true,
      headerTip: '删微客户中为重复客户的数据'
    },
    {
      prop: 'effectiveCount',
      label: '有效资源数',
      minWidth: '110',
      sortable: true,
      headerTip: '添加人数-删微数-重复数+重叠数'
    },
    {label: '操作', minWidth: '60', slotName: 'handler'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
